import { render, staticRenderFns } from "./ModalFriendSearch.vue?vue&type=template&id=69385ef5&"
import script from "./ModalFriendSearch.vue?vue&type=script&lang=js&"
export * from "./ModalFriendSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports